<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div></div>
      <div style="margin: 20px 0">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
        :tree-props="{ children: 'children' }"
      >
        <el-table-column prop="sort" label="排序" align="center" width="230px">
          <template slot-scope="scope">
            <el-input-number style="width: 150px" v-model="scope.row.sort" :precision="0" :min="0" :max="99999999" placeholder="请输入排序" @change="updataSort(scope.row)"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="项目一级分类">
        </el-table-column>
        <el-table-column prop="priceUnit" align="center" label="单位">
        </el-table-column>
        <el-table-column prop="price" align="center" label="单价（元）">
          <template slot-scope="scope">
            {{ scope.row.price == 0 ? '' : scope.row.price }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="创建时间">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >
            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <!-- <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div> -->
      <el-dialog
        :title="visibleTitle"
        :visible.sync="dialogVisible"
        width="50%"
        :close-on-click-modal="false"
        @close="close"
      >
        <el-form
          :model="addData"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="排序" prop="sort">
            <el-input-number style="width: 250px" v-model="addData.sort" :precision="0" :min="0" :max="99999999" placeholder="请输入排序"></el-input-number>
          </el-form-item>
          <el-form-item label="上级分类">
            <el-select clearable filterable v-model="addData.parentId" placeholder="请选择">
              <el-option :label="item.name" :value="item.id" v-for="(item,i) in tableData" :key="i"></el-option>
            </el-select>
            <span style="color: #ff0000;">（不选就是一级）</span>
          </el-form-item>

          <el-form-item label="服务名称" prop="name">
            <el-input
              v-model="addData.name"
              placeholder="请输入服务名称"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位" v-if="addData.parentId" :prop="addData.parentId?'priceUnit':''">
            <el-input
              v-model="addData.priceUnit"
              placeholder="请输入单位"
              maxlength="6"
            ></el-input>
          </el-form-item>
          <el-form-item label="单价（元）" v-if="addData.parentId" :prop="addData.parentId?'price':''">
            <el-input-number style="width: 250px" v-model="addData.price" :precision="2" :min="0" :max="99999999" placeholder="请输入单价（元）"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit('ruleForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sortSum: 0,
      tableData: [],
      visibleTitle: "新增",
      dialogVisible: false,
      sortVisible: false,
      isShowRouter:true,
      addData: {
        id:'',
        name: "",
        parentId:'',
        // price: '',
        priceUnit: '',
        sort: '',
      },
      rules: {
        price: [{ required: true, message: "请输入单价", trigger: "blur" }],
        priceUnit: [{ required: true, message: "请输入单位", trigger: "blur" }],
        name: [{ required: true, message: "请输入服务名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      allList:[],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
    };
  },
  mounted() {
    // this.onLoad();
    this.getAll()
  },
  methods: {
    onLoad() {
      this.isShowloading = true;
      let page = {
        current: this.currentPage,
        size: this.pageSize
      };
      this.tableData = [];
      this.$Apis.orderWorkCategoryPriceList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
          this.dialogVisible = false;
        }
      });
    },
    getAll(){
      this.$Apis.orderWorkCategoryPriceAllList().then(res=>{
        if(res.code == 200){
          this.tableData = res.data
        }
      })
    },
    updataSort(row){
      let data = {
        id: row.id,
        sort: row.sort,
      };
      this.$Apis.orderWorkCategoryPriceSort(data).then((res) => {
        if (res.code == 200) {
          this.getAll();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 删除
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除此项", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.isShowRouter = false
          this.$Apis.orderWorkCategoryPriceDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.isShowRouter = true
              this.getAll()
              this.$message.success("删除成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch((err) => {});
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    // 修改
    updataCharacter(row) {
      row.parentId = row.parentId == "" ? "" : row.parentId;
      this.addData = JSON.parse(JSON.stringify(row));
      this.visibleTitle = "修改";
      this.dialogVisible = true;
    },
    // 新增
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.visibleTitle = "新增";
      
      this.dialogVisible = true;
    },
    close() { 
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      

    },
    // 提交
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = {
            id: this.addData.id || "",
            name: this.addData.name,
            parentId: this.addData.parentId || "",
            price:this.addData.price,
            priceUnit:this.addData.priceUnit,
            sort:this.addData.sort,
          };
          this.btnLoading = true;
          this.$Apis.orderWorkCategoryPriceAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              // this.onLoad();
              this.getAll()
              this.dialogVisible = false;
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script> 

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px 25px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>